import { render, staticRenderFns } from "./AddDepartment.vue?vue&type=template&id=19126744&scoped=true"
import script from "./AddDepartment.vue?vue&type=script&lang=js"
export * from "./AddDepartment.vue?vue&type=script&lang=js"
import style0 from "./AddDepartment.vue?vue&type=style&index=0&id=19126744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19126744",
  null
  
)

export default component.exports